export default __webpack_public_path__ + "static/media/wallet06.c9a93526.png";